import * as React from "react"
import { 
  Create 
} from "react-admin"

import { transformProduct } from "../utils/transformProduct";
import ClothesForm from "./ClothesForm"

const ClothesTitle = () => {
  return <span>{'建立衣服商品'}</span>;
};

const validateForm = (values) => {
  const errors = {};

  if (!values.name) {
    errors.name = "ra.validation.required";
  }

  // 如果上架狀態為 OFF (status 為 false 或 0)，則只檢查名稱欄位
  if (values.status === false || values.status === 0) {
    return errors; // 只檢查名稱，其他欄位不檢查
  }
  
  if (!Array.isArray(values.categories) || values.categories.length === 0) {
    errors.categories = "ra.validation.required";
  }

  if (!values.coverImage?.rawFile && !values.coverImage?.[0]?.title) {
    errors.coverImage = "ra.validation.required";
  }

  if (!values.templateImage?.rawFile && !values.templateImage?.[0]?.title) {
    errors.templateImage = "ra.validation.required";
  }

  if (!values.price) {
    errors.price = "ra.validation.required";
  }

  if (!values.bulkPrice) {
    errors.bulkPrice = "ra.validation.required";
  }

  if (!values.samplingTime) {
    errors.samplingTime = "ra.validation.required";
  }

  if (!values.samplingFee) {
    errors.samplingFee = "ra.validation.required";
  }

  if (!values.blankSampleLeadTimeDays) {
    errors.blankSampleLeadTimeDays = "ra.validation.required";
  }

  if (!values.minQuantity) {
    errors.minQuantity = "ra.validation.required";
  }

  if (!values.maxQuantity) {
    errors.maxQuantity = "ra.validation.required";
  }

  if (!values.incrementStep) {
    errors.incrementStep = "ra.validation.required";
  }

  if (!values.samplingMinOrderQuantity) {
    errors.samplingMinOrderQuantity = "ra.validation.required";
  }

  if (!values.samplingMaxOrderQuantity) {
    errors.samplingMaxOrderQuantity = "ra.validation.required";
  }

  if (!values.samplingIncrementStep) {
    errors.samplingIncrementStep = "ra.validation.required";
  }

  if (!values.bulkMinOrderQuantity) {
    errors.bulkMinOrderQuantity = "ra.validation.required";
  }

  if (!values.bulkMaxOrderQuantity) {
    errors.bulkMaxOrderQuantity = "ra.validation.required";
  }

  if (!values.bulkIncrementStep) {
    errors.bulkIncrementStep = "ra.validation.required";
  }

  // printMethods 驗證
  if (!Array.isArray(values.printMethods) || values.printMethods.length === 0) {
    errors.printMethods = "ra.validation.required";
  } else {
    const ids = values.printMethods
      .map(m => m?.printingMethodId)
      .filter(id => id != null);

    const hasValidMethod = ids.length > 0;
    if (!hasValidMethod) {
      errors.printMethods = "ra.validation.required";
    } else {
      // 檢查是否有重複
      const uniqueIds = new Set(ids);
      if (uniqueIds.size !== ids.length) {
        errors.printMethods = "已選的印製方式有重複";
      }
    }
  }

  // quantityDiscounts 驗證
  if (Array.isArray(values.quantityDiscounts)) {
    const discountsErrors = [];
    values.quantityDiscounts.forEach((item, index) => {
      if (item.minQuantity && item.maxQuantity) {
        const itemErrors = {};
        if (!item.discountPrice) {
          itemErrors.discountPrice = "ra.validation.required";
        }
        if (!item.leadTimeDays) {
          itemErrors.leadTimeDays = "ra.validation.required";
        }
        if (Object.keys(itemErrors).length > 0) {
          discountsErrors[index] = itemErrors;
        }
      }
    });
    if (discountsErrors.length > 0) {
      errors.quantityDiscounts = discountsErrors;
    }
  }

  // editableAreas 驗證
  if (!Array.isArray(values.editableAreas) || values.editableAreas.length === 0) {
    errors.editableAreas = "ra.validation.required";
  } else {
    const editableErrors = [];
    let hasValid = false;

    values.editableAreas.forEach((area, i) => {
      const err = {};

      if (!area.areaName) return;

      if (!area.templateImage?.rawFile && !area.templateImage?.[0]?.title) {
        err.templateImage = "ra.validation.required";
      }

      if (Array.isArray(area.images)) {
        const imageErrors = [];
        let hasImageError = false;

        area.images.forEach((img, j) => {
          if (!img.image?.rawFile && !img.image?.[0]?.title) {
            imageErrors[j] = { image: "ra.validation.required" };
            hasImageError = true;
          }
        });

        if (hasImageError) {
          err.images = imageErrors;
        }
      }

      if (Object.keys(err).length > 0) {
        editableErrors[i] = err;
      } else {
        hasValid = true;
      }
    });

    if (!hasValid) {
      errors.editableAreas = "ra.validation.required";
    } else if (editableErrors.length > 0) {
      errors.editableAreas = editableErrors;
    }
  }

  return errors;
};

const ClothesCreate = () => {
  return (
    <Create 
      title={<ClothesTitle/>} 
      transform={transformProduct}
    >
      <ClothesForm />
    </Create>
  )
}

export default ClothesCreate